import Miscellaneous from './Miscellaneous.vue';
export default Miscellaneous;
